import { useEffect } from "react";
import { Brand } from "../configurations/index.js";
import {
  AlbertaMigrationCountry,
  AlbertaMigrationState,
  Channel,
  DialogType,
  Topic
} from "../constants/index.js";
import { AppFeatures } from "../constants/featureFlags.js";
import { MessageBrokerUtils, PageContextUtils } from "../utils/index.js";
import { useFeatureFlag } from "./useFeatureFlag.js";

const isAlbertaPlayer = () => {
  const { country, state } = PageContextUtils.getGlobalizationData() || {};
  const { brandId } = PageContextUtils.getBrandData() || {};

  return (
    brandId === Brand.Sport_Com &&
    country?.toLowerCase() === AlbertaMigrationCountry &&
    state?.toLowerCase() === AlbertaMigrationState
  );
};

export const useAlbertaMigrationBlock = () => {
  const isAlbertaMigrationBlockEnabled = useFeatureFlag(
    AppFeatures.ALBERTA_MIGRATION_BLOCK
  );

  useEffect(() => {
    if (!isAlbertaMigrationBlockEnabled) return;
    if (!isAlbertaPlayer()) return;
    MessageBrokerUtils.publish({
      channel: Channel.UI,
      topic: Topic.toggleBottomBar,
      headers: { publisher: "UAA" },
      data: { visible: false }
    });
    MessageBrokerUtils.publish({
      channel: Channel.UI,
      topic: Topic.DialogShow,
      headers: { publisher: "UAA" },
      data: { dialogType: DialogType.AlbertaMigrationBlock }
    });
  }, [isAlbertaMigrationBlockEnabled]);
};
